<template>
  <v-dialog v-model="dialog" width="500">
    <v-card>
      <validation-observer v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <v-card-title class="headline grey lighten-2" primary-title>Create a new POU</v-card-title>

          <v-card-text>
            <v-container>
              <validation-provider
                :vid="uuid()"
                name="POU Name"
                :rules="`required|pouName:${$store.state.addItem.itemTempId}`"
                v-slot="{ errors }"
              >
                <v-row>
                  <v-text-field label="POU Name" v-model="pou.name"></v-text-field>
                </v-row>

                <v-row>
                  <span class="validation-message">{{ errors[0] }}</span>
                </v-row>
              </validation-provider>

              <v-row>
                <v-select label="POU Type" :items="pouTypes" v-model="pou.pouType"></v-select>
              </v-row>
              <validation-provider
                :vid="uuid()"
                name="Language"
                rules="required"
                v-slot="{ errors }"
              >
                <v-row>
                  <v-select label="Language" :items="languages" v-model="pou.body.language"></v-select>
                </v-row>

                <v-row>
                  <span class="validation-message">{{ errors[0] }}</span>
                </v-row>
              </validation-provider>
            </v-container>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="dialog = false">Cancel</v-btn>
            <v-btn color="primary" text type="submit">Save</v-btn>
          </v-card-actions>
        </form>
      </validation-observer>
    </v-card>
  </v-dialog>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { find, cloneDeep } from "lodash";
import uuid from "src/mixins/uuid";

export default {
  components: { ValidationObserver, ValidationProvider },
  mixins: [uuid],
  data() {
    return {
      pouTypes: ["function", "functionBlock", "program"],
      languages: ["IL", "ST", "FBD", "LD", "SFC"],
    };
  },
  computed: {
    pou() {
      if (
        this.$store.state.addItem.componentName === "AddPou" &&
        this.$store.state.addItem.itemTempId
      ) {
        return cloneDeep(
          find(this.$store.state.pous, {
            tempId: this.$store.state.addItem.itemTempId,
          })
        );
      }

      return {
        pouType: this.$store.state.addItem.pouType,
        tempId: this.uuid(),
        body: {
          data: {},
        },
      };
    },
    dialog: {
      get() {
        return (
          this.$store.state.addItem.componentName === "AddPou" &&
          this.$store.state.addItem.showDialog
        );
      },
      set(newValue) {
        this.$store.dispatch("clearAddItem");
      },
    },
  },
  methods: {
    submit() {
      if (this.$store.state.addItem.itemTempId) {
        this.$store.dispatch("updatePou", this.pou);
      } else {
        this.$store.dispatch("addPou", {
          ...this.pou,
          variables: [],
          tempId: this.uuid(),
        });
      }

      this.$store.dispatch("clearAddItem");
    },
  },
};
</script>
